<div class="common-drop-down common-drop-down-arrow"
  [className]="validate && isValidated(selectedItemId) ? 'invalid-drop-down-input' : 'drop-down-input'">
  <span class="name">{{name}}</span>
  <ng-select [clearable]="false" [searchable]="searchable" [placeholder]="placeholder" (blur)="onSaveModelDropDown()" (focus)="onSaveState()" [(ngModel)]="selectedItemId"
             class="custom" (change)="onSelectedItemIdChange()" [disabled]="!!disabled" (keyup)="onValueChange($event)" (click) = "onMouseClick($event)"
             [attr.data-testid]="testId">
    @for (item of items; track item) {
      <ng-option [value]="item.id" >{{item.name}}</ng-option>
    }
  </ng-select>
</div>
